import Swiper from 'swiper';
import { EffectFade, Navigation } from 'swiper/modules';
(function ($) {
    $('body')
        .find('.js-accessory-slider')
        .each(function () {
            let $this = $(this),
                $nav = $this.find('.js-accessory-slider-nav');

            $nav.on('click', function () {
                let $that = $(this),
                    target = $that.attr('data-target');

                swiper.slideTo(target);
            });
            const swiper = new Swiper($this[0], {
                modules: [EffectFade, Navigation],
                slidesPerView: 1,
                crossFade: true,
                effect: 'fade',
                navigation: {
                    nextEl: $this[0].querySelector('.swiper-button-next'),
                    prevEl: $this[0].querySelector('.swiper-button-prev'),
                },
            });
        });
})(jQuery);
